import api from './api.service';

export const notificacionService = {
  getAll: async () => {
    const { data } = await api.get('/notificaciones');
    return data;
  },

  marcarLeida: async (id: number): Promise<void> => {
    await api.put(`/notificaciones/${id}/leer`);
  },

  marcarTodasLeidas: async (): Promise<void> => {
    await api.put('/notificaciones/leer-todas');
  }
};
